import { Outlet } from "react-router-dom";
import { LayoutList } from "lucide-react";
import { NavItem } from "@/components/layout/Menu/MenuGridIcon";
import { MenuRowIcon } from "@/components/layout/Menu/MenuRowIcon";

export function TestingMenu() {
	const navItems: NavItem[] = [
		{ label: 'Loading', to: '/test/loadings', icon: <LayoutList size={32} /> },
	];

	return <>
		<MenuRowIcon menus={navItems} />
		<div className="p-2">
			<Outlet />
		</div>
	</>
}

